import { Color } from "../enums/Color";

export const recruiterProfileArea = {
    mobile: { 
        searchWrapper: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexDirection: "row" as "row",
            height: "4.68vw"
        },
        searchBar: {
            display: "flex",
            alignItems: 'center',
            position: 'relative',
            backgroundColor: Color.Cultured,
            input: {
                border: "none",
                backgroundColor: Color.Cultured
            },
            icon: {
                position: "absolute" as "absolute",
                fill: Color.SharpAsh
            }
        }
    },
    desktop: {
        searchBar: {
            marginTop: "0.52vw",
            marginBottom: "1.56vw",
            width: "25.21vw",
            borderRadius: "0.52vw",
            height: "2.6vw",
            input: {
                width: "21vw",
                paddingLeft: "1.04vw"
            },
            icon: {
                width: "1.14vw",
                height: "1.25vw",
                left: '23.06vw',
                cursor: "pointer"
            }
        },
        profileEntrance: {
            position: "absolute" as "absolute",   
            right: "1.56vw",         
            dropdownLabel: {
                position: "relative" as "relative",
                textDecoration: "none",
                fontSize: "0.937vw",
                fontWeight: "medium",
                letterSpacing: "0px",
                color: Color.MiddleBlack,
                cursor: "pointer",
                opacity: "1"
            },
            logoutDropdownLabel: {
                color: Color.Red
            },
            logoutIcon: {
                float: "right",
                width: "0.67vw",
                height: "0.572vw"
            },
            logoutDropdownItem: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                hover: {
                    fill: Color.White,
                    backgroundColor: Color.Blue,                    
                    borderRadius: "0.4vw",
                    padding: "0.36vw",
                    color: Color.White
                },
                leave: {
                    fill: Color.Red,
                    backgroundColor: Color.White,
                    padding: "0.36vw"
                }
            },
            dropdownItem: {
                color: Color.MiddleBlack,
                fontSize: "0.83vw",
                fontWeight: "500",
                hover: {
                    backgroundColor: Color.Blue,                    
                    borderRadius: "0.36vw",
                    padding: "0.31vw 0.52vw",
                    color: Color.White
                },
                leave: {
                    backgroundColor: Color.White,
                    padding: "0.31vw 0.52vw"
                }
            },
            notifyButton: {
                position: "relative" as "relative",
                width: "2.9vw",
                height: "2.9vw",
                marginRight: "1.46vw",
                marginTop: "5vh",
                backgroundColor: Color.White,
                border: "none",
                borderRadius: "50%",
                cursor: "pointer"
            },
            notifyIcon: {
                width: "1.31vw",
                height: "1.31vw",
                fill: Color.Blue
            },
            userWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                marginLeft: "unset",
                marginTop: "unset"
            },
            userDropdown: {
                wrapper: {
                    display: "inline-block"
                },
                button: {
                    backgroundColor: "transparent",
                    color: Color.LightAsh,
                    fontSize: "1.17vw",
                    fontWeight: 500,
                    border: "none",
                    cursor: "pointer"
                },
                item: {
                    textAlign: "left"
                },
                labelWrapper: {
                    display: "flex",
                    flexDirection: "row" as "row"
                },
                labelIcon: {
                    width: "1.09vw",
                    height: "1.09vw",
                    fill: Color.DeepBlack,
                    marginLeft: "1.35vh",
                    marginTop: "4vh",
                    transition: "transform 0.1s linear",
                    hover: {
                        transform: "rotate(180deg)"
                    }
                },
                label: {
                    textDecoration: "none",
                    fontSize: "1.17vw",
                    letterSpacing: "0px",
                    color: Color.LightAsh,
                    opacity: "1"
                },
                leave: {
                    display: "none"
                },
                hover: {
                    display: "block",
                    position: "absolute" as "absolute",
                    width: "22vh",
                    height: "auto",
                    padding: "0.6vw",
                    right: 0,
                    backgroundColor: Color.White,
                    boxShadow: "0 0.2vw 1.35vh rgb(0 0 0 / 0.5)",
                    borderRadius: "1.35vh",
                    zIndex: 3
                },
                bottomBorder: {
                    border: 0,
                    height: "1px",
                    width: "92%",
                    background: Color.MiddleAsh,
                    margin: "0 auto",
                    zIndex: "1"
                },
                hoveredBorder: {
                    background: Color.White,
                    borderRadius: "1px"
                }
            },
            userAvatar: {
                height: "3.66vw",
                width: "3.66vw",
                border: "0.5vw solid " + Color.Green,
                borderRadius: "50%",
                cursor: "pointer"
            },
            userName: {
                display: "none"
            }
        }
    }
}